import { api } from '@/global/services/api'
import { ref } from 'vue'

export function useAutocompleteItems () {
  const unitOfMeasureItems = ref([])

  const fetchUnitOfMeasureItems = async () => {
    try {
      const { data } = await api('road-maintenance').get('traffic-regulation/codebook', {
        types: ['UNIT_OF_MEASURE']
      })

      if (data?.unit_of_measure?.length) {
        unitOfMeasureItems.value = data?.unit_of_measure
      }
    }
    catch (exception) {
      console.error(exception)
    }
  }

  return {
    unitOfMeasureItems,
    fetchUnitOfMeasureItems
  }
}
